import { render } from "./AposInputRadio.vue?vue&type=template&id=66944608&scoped=true"
import script from "./AposInputRadio.vue?vue&type=script&lang=js"
export * from "./AposInputRadio.vue?vue&type=script&lang=js"

import "./AposInputRadio.vue?vue&type=style&index=0&id=66944608&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66944608"],['__file',"schema/ui/apos/components/AposInputRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66944608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66944608', __exports__)) {
    api.reload('66944608', __exports__)
  }
  
  module.hot.accept("./AposInputRadio.vue?vue&type=template&id=66944608&scoped=true", () => {
    api.rerender('66944608', render)
  })

}


export default __exports__